import React from 'react';
import ReactDOM from 'react-dom';
import './globals'; 
//import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/bootstrap-qrsticker.min.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { Router } from 'react-router-dom';
import history from './authentication/History';

ReactDOM.render((
    <Router history={history}>
        <App />
    </Router>
  ), document.getElementById('root'))
  unregister();
